import _ from "underscore";
import Tree from "../tree/Tree";
import TreeSelectionController from "./TreeSelectionController";

export default function SelectionTree( rootNode, rootVisible, collapsedNodeIds )
{
    Tree.call( this, rootNode, rootVisible, collapsedNodeIds );
    this.selectionController = this.createSelectionController();
}

SelectionTree.prototype = _.create(Tree.prototype);

/*
todo : radzivillovich : need to refactor
type of selection controller shouldn't be strictly associated with type of selection tree.
so we, probably, should set selection controller to tree after tree creating
*/
SelectionTree.prototype.createSelectionController = function()
{
    return new TreeSelectionController(this);
};

SelectionTree.prototype.setSelectionController = function(selectionController)
{
    this.selectionController = selectionController;
};

SelectionTree.prototype.getSelectionController = function()
{
    return this.selectionController;
};

SelectionTree.prototype.deselectAll = function()
{
    this.selectionController.deselectAll();
};






// WEBPACK FOOTER //
// ./web/js/hierarchySelector/selectionTree/SelectionTree.js